$(document).ready(function() {
$.cookieBar();
});


$(document).ready(function() {
$('.cookie-message').cookieBar({ closeButton : '.my-close-button', hideOnClose: false });
$('.cookie-message').on('cookieBar-close', function() { $(this).slideUp(); });
});


(function ($) {
$.cookie = function (key, value, options) {
if (arguments.length > 1 && (!/Object/.test(Object.prototype.toString.call(value)) || value === null || value === undefined)) {
options = $.extend({}, options);

if (value === null || value === undefined) {
options.expires = -1;
}

if (typeof options.expires === 'number') {
var days = options.expires, t = options.expires = new Date();
t.setDate(t.getDate() + days);
}

value = String(value);

return (document.cookie = [
encodeURIComponent(key), '=', options.raw ? value : encodeURIComponent(value),
options.expires ? '; expires=' + options.expires.toUTCString() : '', // max-age is not supported by IE
options.path ? '; path=' + options.path : '',
options.domain ? '; domain=' + options.domain : '',
options.secure ? '; secure' : ''
].join(''));
}
options = value || {};
var decode = options.raw ? function (s) { return s; } : decodeURIComponent;
var pairs = document.cookie.split('; ');
for (var i = 0, pair; pair = pairs[i] && pairs[i].split('='); i++) {
// IE
if (decode(pair[0]) === key) return decode(pair[1] || '');
}
return null;
};

$.fn.cookieBar = function (options) {
var settings = $.extend({
'closeButton': 'none',
'hideOnClose': true,
'secure': false,
'path': '/',
'domain': ''
}, options);

return this.each(function () {
var cookiebar = $(this);

// just in case they didnt hide it by default.
cookiebar.hide();

// if close button not defined. define it!
if (settings.closeButton == 'none') {
cookiebar.append('<a class="cookiebar-close">X</a>');
$.extend(settings, { 'closeButton': '.cookiebar-close' });
}

if ($.cookie('cookiebar') != 'hide') {
cookiebar.show();
}

cookiebar.find(settings.closeButton).click(function () {
if (settings.hideOnClose) {
cookiebar.hide();
}
$.cookie('cookiebar', 'hide', { path: settings.path, secure: settings.secure, domain: settings.domain, expires: 30 });
cookiebar.trigger('cookieBar-close');
return false;
});
});
};

// self injection init
$.cookieBar = function (options) {
$('.footer').prepend("<div class='ui-widget'><div style='display: none;' class='cookie-message ui-widget-header blue'><div class='cookie-text'><p>Shore Projects uses cookies to ensure that we give you the best experience on our website. If you continue without changing your cookie setting, we'll assume that you are agreeing to our use of cookies. Find out more by reading our<a href='https://usa.shoreprojects.com/pages/customer-care#terms'>Cookie Policy.</a></p> </div></div></div>");
$('.cookie-message').cookieBar(options);
};
})(jQuery);
(function(e){e.cookie=function(o,i,n){if(arguments.length>1&&(!/Object/.test(Object.prototype.toString.call(i))||null===i||void 0===i)){if(n=e.extend({},n),null!==i&&void 0!==i||(n.expires=-1),"number"==typeof n.expires){var t=n.expires,r=n.expires=new Date;r.setDate(r.getDate()+t)}return i=String(i),document.cookie=[encodeURIComponent(o),"=",n.raw?i:encodeURIComponent(i),n.expires?"; expires="+n.expires.toUTCString():"",n.path?"; path="+n.path:"",n.domain?"; domain="+n.domain:"",n.secure?"; secure":""].join("")}n=i||{};for(var c,s=n.raw?function(e){return e}:decodeURIComponent,a=document.cookie.split("; "),u=0;c=a[u]&&a[u].split("=");u++)if(s(c[0])===o)return s(c[1]||"");return null},e.fn.cookieBar=function(o){var i=e.extend({closeButton:"none",hideOnClose:!0,secure:!1,path:"/",domain:""},o);return this.each(function(){var o=e(this);o.hide(),"none"==i.closeButton&&(o.append('<a class="cookiebar-close">X</a>'),e.extend(i,{closeButton:".cookiebar-close"})),"hide"!=e.cookie("cookiebar")&&o.show(),o.find(i.closeButton).click(function(){return i.hideOnClose&&o.hide(),e.cookie("cookiebar","hide",{path:i.path,secure:i.secure,domain:i.domain,expires:30}),o.trigger("cookieBar-close"),!1})})},e.cookieBar=function(o){e(".footer").prepend("<div class='ui-widget'><div style='display: none;' class='cookie-message ui-widget-header blue'><div class = 'cookie-text'><p>Shore Projects uses cookies to ensure that we give you the best experience on our website. If you continue without changing your cookie setting, we'll assume that you are agreeing to our use of cookies. Find out more by reading our <a href='https://usa.shoreprojects.com/pages/customer-care#terms'>Cookie Policy.</a></p> </div></div></div>"),e(".cookie-message").cookieBar(o)}})(jQuery);
 